export default __webpack_public_path__ + "static/media/drmc-tech.a6e008c6.jpg";